import { CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  useQuadMediaApiToken,
  type TokenWithMonitoring,
} from "@/features/auth/hooks/useApiToken";
import { TAB_ORDER } from "../../config";
import { useSourceBasedStore } from "../../store/sourceStore";
import { MediaTabs } from "./SourceMediaTabs";
import { useTokenValidation } from "@/hooks/useTokenValidation";
interface NavigationProps {
  isFirstTab: boolean;
  isLastTab: boolean;
  nextLabel: string;
  onNext: () => void;
  onBack: () => void;
  onLaunch?: () => void;
}

interface MediaStepperPageProps {
  navigationProps?: NavigationProps;
  selectedToken?: TokenWithMonitoring | null;
}

export default function MediaStepperPage({
  navigationProps,
  selectedToken,
}: MediaStepperPageProps) {
  // const search = useSourceBasedStore((s) => s.search);
  // const setSearch = useSourceBasedStore((s) => s.setSearch);
  const { activeTab, selectedPublications } = useSourceBasedStore();
  const { apiToken } = useQuadMediaApiToken();
  const currentTabIndex = TAB_ORDER.indexOf(activeTab);
  const isFirstTab = currentTabIndex === 0;
  const isLastTab = currentTabIndex === TAB_ORDER.length - 1;

  // Universal token validation
  const { isLaunchDisabled, effectiveToken } = useTokenValidation({
    apiToken,
    selectedToken,
    showTokenDropdown: true,
    additionalValidation: () => selectedPublications.length > 0,
  });

  const formatTabLabel = (tab?: string) => {
    if (!tab) return "";
    if (tab.toLowerCase() === "tv") return "TV";
    return tab.charAt(0).toUpperCase() + tab.slice(1);
  };

  return (
    <div className="flex min-h-full flex-col gap-5 pr-3">
      {/* Header row */}
      <div className="flex items-center justify-between">
        <div>
          <CardTitle className="text-[28px] !leading-[36px] !-tracking-wide text-neutral-950">
            Source Monitoring
          </CardTitle>
        </div>
        {/* <SearchBar value={search} onChange={setSearch} /> */}
      </div>

      {/* Tabs */}
      <div className="min-h-0 flex-1">
        <MediaTabs />
      </div>

      {/* Navigation at bottom */}
      {navigationProps && (
        <div className="flex w-full flex-shrink-0 flex-row justify-start gap-3 px-2 pt-6">
          {!isFirstTab && (
            <Button
              variant="outline"
              icon
              onClick={navigationProps.onBack}
              className="h-[48px] w-[160px] hover:scale-none"
            >
              Back
            </Button>
          )}

          {!isLastTab ? (
            <Button
              variant="default"
              icon
              onClick={navigationProps.onNext}
              className="h-[48px] w-[240px] hover:scale-none"
            >
              Next: {formatTabLabel(TAB_ORDER[currentTabIndex + 1])}
            </Button>
          ) : (
            <Button
              variant="default"
              icon
              onClick={navigationProps.onLaunch}
              className="h-[48px] w-[240px] hover:scale-none"
              disabled={isLaunchDisabled || selectedPublications.length === 0}
            >
              {effectiveToken ? (
                <>
                  <i className="ri-arrow-right-s-fill text-[18px]"></i>
                  Launch
                </>
              ) : (
                "Missing API Token"
              )}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
